import { Component, OnInit } from '@angular/core';
import {
  ConfiguratorCertificateApiService
} from '../../../services/api/settings/configurator-certificate/configurator-certificate-api.service';
import _ from 'lodash';
import {changeCertificateMessage} from '../../../components/certificates/certificate/certificate.component';
import {FileSaverService} from 'ngx-filesaver';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {AcDialogService} from 'ac-infra';
import {CertificateViewComponent} from '../../../components/certificates/certificate-view/certificate-view.component';
import {
  CertificateReloadDialogComponent
} from '../../../components/certificates/certificate-reload-dialog/certificate-reload-dialog.component';

@Component({
  selector: 'configurator-certificate',
  templateUrl: './configurator-certificate.component.html',
  styleUrls: ['./configurator-certificate.component.scss']
})
export class ConfiguratorCertificateComponent implements OnInit {

  constructor(private configuratorCertificateApiService: ConfiguratorCertificateApiService,
              private fileSaverService: FileSaverService,
              private dialog: MatDialog,
              private acDialogService: AcDialogService) { }

  ngOnInit(): void {
  }

  onGenerateCertificateSubmit(configuratorCertificate): void {
    if (configuratorCertificate.generateType === 'privateKeyAndSelfSigned') {
      this.configuratorCertificateApiService.generateKeystore(configuratorCertificate).subscribe(data => {
        const fileType = {type: 'text/jks'};
        const blob = new Blob([data], fileType);

        this.fileSaverService.save(blob, 'arm_keystore.jks');
      });
    } else if (configuratorCertificate.generateType === 'replacePrivateKeyAndSelfSigned') {
      const confirmationMessage = `Generating a self-signed key ${changeCertificateMessage}`;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '460px',
        data: {
          message: confirmationMessage
        }
      });

      dialogRef.componentInstance.onApply.subscribe(() => {
        this.configuratorCertificateApiService.generateAndReplaceKeystore(configuratorCertificate).subscribe(
          (data) => {
            dialogRef.close();
            this.displayReloadPageDialog(data);
          });
      });
    } else if (configuratorCertificate.generateType === 'privateKeyAndCsr') {
      this.configuratorCertificateApiService.generatePrivateKeyAndCsr(configuratorCertificate).subscribe(
        data => {
          const fileType = {type: 'application/octet-stream'};
          const blob = new Blob([data], fileType);
          this.fileSaverService.save(blob, 'arm_keystore.zip');
        });
    }
  }

  onLoadCertificateSubmit(uploadCertificate): void {
    if (!_.isNil(uploadCertificate.keyStoreFile) && !_.isNil(uploadCertificate.csrfile)) {
      this.configuratorCertificateApiService.uploadConfigurationKeystoreAndCsr(uploadCertificate).subscribe(
        (data) => {
          this.displayReloadPageDialog(data);
        });
    } else if (!_.isNil(uploadCertificate.keyStoreFile)) {
      this.configuratorCertificateApiService.uploadConfigurationKeystore(uploadCertificate).subscribe(
        (data) => {
          this.displayReloadPageDialog(data);
        });
    }
  }

  onViewCurrentCertificate(): void {
    this.configuratorCertificateApiService.getCurrentCertificate().subscribe(data => {
      this.acDialogService.open(CertificateViewComponent, {title: 'Current Certificate',
        dialogData: data});
    });
  }

  private displayReloadPageDialog(data): void {
    const countdownInSeconds = data && data.tomcatReset ? 5 : 5;
    this.acDialogService.open(CertificateReloadDialogComponent, {
      dialogData: {
        message: `The certificate was changed successfully.
        The application will be refreshed automatically.`,
        countdownInSeconds,
        action:  () => window.location.reload()
      }});
  }

}
